import { lazy } from 'react';

const ServiceAreasPendingPage = lazy(() => import('./ServiceAreasPendingPage'));
const NotFound = lazy(() => import('../../app/views/NotFound'));

const serviceAreasPendingRoutes = [
  {
    path: 'pending',
    children: [
      { index: true, element: <ServiceAreasPendingPage /> },
      { path: 'theatre-list', element: <ServiceAreasPendingPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default serviceAreasPendingRoutes;
